
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="forgot-password-section"
  >
  <div class="amplify-form-body" data-test="forgot-password-body-section">
  <div
    class="amplify-form-header amplify-form-header-ionic"
    data-test="forgot-password-header-section"
    >
    {{ this.amplifyService.i18n().get('Reset your password') }}
  </div>
  <div class="amplify-form-text" *ngIf="!code_sent">
    {{ this.amplifyService.i18n().get('You will receive a verification code to reset your password') }}
  </div>

  <ion-list>
    <amplify-auth-username-field-ionic
      [usernameAttributes]="_usernameAttributes"
      (usernameFieldChanged)="onUsernameFieldChanged($event)"
    ></amplify-auth-username-field-ionic>
    <ion-item lines="none" *ngIf="code_sent">
      <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
        {{ this.amplifyService.i18n().get('Code *') }}
      </ion-label>
      <ion-input
        #code
        type="text"
        class="amplify-form-input"
        (input)="setCode(code.value)"
        data-test="forgot-password-code-input"
      ></ion-input>
    </ion-item>
    <ion-item lines="none" *ngIf="code_sent">
      <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
        {{ this.amplifyService.i18n().get('Password *') }}
      </ion-label>
      <ion-input
        #password
        type="password"
        class="amplify-form-input"
        (input)="setPassword(password.value)"
        (keyup.enter)="onSubmit()"
        data-test="forgot-password-new-password-input"
      ></ion-input>
    </ion-item>
  </ion-list>
  <div class="amplify-form-actions">
    <div>
      <ion-button expand="block" color="primary"
        (click)="onSend()"
        *ngIf="!code_sent"
        data-test="forgot-password-submit-button"
      >
        {{ this.amplifyService.i18n().get('Submit') }}</ion-button>
      <ion-button expand="block" color="primary"
      *ngIf="code_sent"
      (click)="onSubmit()"
      >{{ this.amplifyService.i18n().get('Verify') }}</ion-button>
    </div>
    <div class="amplify-form-row">
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Have an account?') }}
        <a class="amplify-form-link" (click)="onSignIn()">
          {{ this.amplifyService.i18n().get('Sign In') }}
        </a>
      </div>
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Lost your code?') }}
        <a
          class="amplify-form-link"
          (click)="onSend()"
          data-test="forgot-password-resend-code-link"
          >
          {{ this.amplifyService.i18n().get('Resend') }}
        </a>
      </div>
    </div>
  </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
